import { useState, useEffect } from 'react';
import HtmlViewer from './htmlView';
import HtmlViewClient from './htmlViewClient';

// Wrapper component for async HtmlViewer
const HtmlViewerWrapper: React.FC<{ linkId: string }> = ({ linkId }) => {
  const [html, setHtml] = useState<string>('');
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const loadContent = async () => {
      try {
        setLoading(true);
        setError(null);
        const htmlContent = await HtmlViewer({ linkId });
        setHtml(htmlContent);
      } catch (error) {
        console.error('Error loading HTML content:', error);
        setError('Error loading content');
      } finally {
        setLoading(false);
      }
    };

    loadContent();
  }, [linkId]);

  if (loading) {
    return <div>Loading...</div>;
  }

  if (error) {
    return <div>{error}</div>;
  }

  return <HtmlViewClient html={html} />;
};

export default HtmlViewerWrapper;
